import Config from '@config';
import { initializeServicesApi } from '@gasbi/shared/common/features/services';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const baseServicesApi = initializeServicesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const { useGetUserServicesQuery } = baseServicesApi;

// Invalidated in realtime via useServicesRealtimeSync (UserServicesUpdated push), once the
// backend confirms the access-cache refresh actually landed — see ServicesRealtimeSync.
export const servicesApi = baseServicesApi.servicesApi.enhanceEndpoints({
  addTagTypes: ['UserServices'],
  endpoints: {
    getUserServices: { providesTags: ['UserServices'] },
  },
});
